const imgTeamGraphic2Postcards = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const img12032 = "./assets/figma/7f2a7ce8-be0d-428a-8606-8c1344abe439.png";
const img2026923382 = "./assets/figma/221a0709-28db-4d8c-a722-6c06f1ed6284.png";
const img2026923372 = "./assets/figma/06d5533b-ffa3-4942-a40c-4910afc87dee.png";
const img2026923373 = "./assets/figma/01051303-3827-4a66-ab58-6b9c95b95078.png";
const img2026923383 = "./assets/figma/418cccde-c404-479a-9d33-5dd4ffac3b77.png";
const img2026923384 = "./assets/figma/499d08db-cdaa-42da-9329-1fa92527a224.png";
const img2026923385 = "./assets/figma/10b9af6d-7016-4cc1-bdab-56e95e2535e6.png";
const imgRectangle245 = "./assets/figma/0470d51d-5596-4e3f-9712-8c5cae2ec5cf.png";
const img15Png1 = "./assets/figma/06fc82b9-1f57-4f3e-9650-6d3cbe3b5f0b.png";
const imgKakaoTalkPhoto202609152233200021 = "./assets/figma/b8edeba2-9cbe-41da-8a75-7a1d950b4986.png";
const imgKakaoTalkPhoto202609152233200031 = "./assets/figma/4860ec19-0f9e-46db-978d-e254dab03493.png";
const imgKakaoTalkPhoto202609152233210061 = "./assets/figma/aec58233-a4b4-472c-8db1-259eabf8c4b6.png";
const imgKakaoTalkPhoto202609152233210081 = "./assets/figma/bf014c30-4633-4b13-a6ae-4cd9d2777eb5.png";
const imgKakaoTalkPhoto202609152233190011 = "./assets/figma/8c4d7aed-9bd4-49ba-ac3c-73fb1c713999.png";
const imgKakaoTalkPhoto202609152233210041 = "./assets/figma/2ac95287-0d5e-4b1f-9480-1e710ce22f12.png";
const imgKakaoTalkPhoto202609152233210091 = "./assets/figma/b7793486-7b44-45a4-a9d7-57b140bf613a.png";
const imgKakaoTalkPhoto202609152233210051 = "./assets/figma/b1e4551c-d376-4d5f-b1b0-40e384ae0a66.png";
const imgKakaoTalkPhoto202609152233210071 = "./assets/figma/829b30e8-95a5-4bf7-9722-ff7a1b420810.png";
const imgLine21 = "./assets/figma/024cae05-40d5-40cd-8187-3cfbbb55f6fe.svg";
const img1 = "./assets/figma/21ca5cf9-50e3-4e24-9fdb-81356a1c46b8.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgRectangle246 = "./assets/figma/9357217e-4eb8-409c-af80-fdc2e60ecc28.svg";
const imgRectangle247 = "./assets/figma/a9a51911-596a-4a5d-a924-47cc78192721.svg";
const imgClose = "./assets/figma/92ad8392-f69a-491e-8c9b-d0c8cd8f20f7.svg";

export default function TeamGraphic2Postcards() {
  return (
    <div className="s0 s1" data-node-id="875:2625" data-name="TEAM_GRAPHIC_2/POSTCARDS">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <div className="s2 s3 s6">
          <img alt="" className="s2 s914 s661 s9 s10 s662" src={imgTeamGraphic2Postcards} />
        </div>
      </div>
      <div className="s2 s12 s663 s915 s15" data-node-id="875:2627" data-name="image 14" />
      <div className="s2 s16 s17 s18 s19 s664 s916 s22" data-node-id="875:2628">
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s30" data-node-id="875:2629">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:2630">
            PROJECT OVERVIEW
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="875:2631">
            POSTERS · A2 · 4<br aria-hidden />
            GUIDE CARDS · 160 × 100 MM · 9<br aria-hidden />
            POSTCARDS · 100 × 150 MM · 8<br aria-hidden />
            <br aria-hidden />
          </p>
        </div>
        <div className="s17 s41 s18 s42 s0 s28 s43" data-node-id="875:2632">
          <div className="s44 s45">
            <div className="s46 s0 s47">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine21} />
              </div>
            </div>
          </div>
        </div>
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s50" data-node-id="875:2633">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:2634">
            MEMBERS
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="875:2635">
            강다원
            <br aria-hidden />
            고이룸
            <br aria-hidden />
            박성연
            <br aria-hidden />
            박세현
          </p>
        </div>
      </div>
      <p className="s23 s2 s51 s32 s52 s27 s29 s33 s917 s54" data-node-id="875:2636">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <div className="s23 s2 s16 s17 s24 s25 s26 s665 s27 s29 s918 s57" data-node-id="875:2637">
        <p className="s31 s32 s0 s28 s58 s59" data-node-id="875:2638">
          ABOUT
        </p>
        <div className="s35 s36 s0 s28 s37 s59 s38" data-node-id="875:2639">
          <p className="s39 s40">{`그래픽 2팀은 유리관을 연결하고 조립한 타이포그래피로 DING AI LAB의 이름과 실험실이라는 공간적 특성을 시각화했다. `}</p>
          <p className="s39 s40">{`기하학적 형태와 색의 그라데이션이 겹치고 어우러지는 배경을 통해 다양한 아이디어가 모여 조화를 이루는 모습을 표현했으며, `}</p>
          <p className="s39 s40">{`텍스트를 그래픽과 연결해 활동 순서와 슬로건의 정보 위계를 정리했다. 엽서에는 서로 다른 AI의 특성과 아이디어가 변화·확장되는 과정을 `}</p>
          <p className="s39 s40">{`고유 색상, 투명 파이프와 구체로 담았다. 8가지 AI 가이드 카드에는 핵심 기능, 활용 분야, 프롬프트 예시, 사용 팁과 주의사항을 캐릭터와 `}</p>
          <p className="s39">{`색상으로  구분해 복잡한 정보를 친근하고 명확하게 전달했다.`}</p>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s621 s27 s29 s61 s919 s54" data-node-id="875:2640">
        GRAPHIC 2
      </p>
      <div className="s2 s623 s666 s918 s625" data-node-id="875:2641" data-name="이미지 1203 2">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={img12032} />
      </div>
      <p className="s23 s2 s31 s32 s63 s27 s29 s64 s920 s66" data-node-id="875:2642">
        WORK
      </p>
      <div className="s2 s16 s17 s627 s18 s36 s63 s921 s66" data-node-id="875:2643">
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2644">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2645" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s341 s342 s9 s10 s343" src={img2026923382} />
            </div>
          </div>
          <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2646" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2647" />
          <p className="s23 s192 s31 s32 s667 s346 s27 s0 s198 s29 s33 s85 s668" data-node-id="875:2648">
            POSTER 1
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2649">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2650" data-name="이미지 2026. 9. 2. 오후 3.37 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s629 s630 s9 s631 s632" src={img2026923372} />
            </div>
          </div>
          <div className="s76 s192 s344 s69 s653 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2651" />
          <div className="s80 s192 s81 s69 s633 s340 s82 s0 s70 s198 s71" data-node-id="875:2652" />
          <p className="s23 s192 s31 s94 s669 s346 s27 s0 s198 s29 s33 s85 s304" data-node-id="875:2653">
            POSTER 2
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2654">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2655" data-name="이미지 2026. 9. 2. 오후 3.37 3">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s634 s635 s9 s636 s637" src={img2026923373} />
            </div>
          </div>
          <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s79 s71" data-node-id="875:2656" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2657" />
          <p className="s23 s192 s31 s94 s670 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:2658">
            POSTER 3
          </p>
        </div>
      </div>
      <div className="s2 s16 s17 s627 s18 s36 s63 s922 s66" data-node-id="875:2659">
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2660">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2661" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s341 s640 s9 s641 s343" src={img2026923383} />
            </div>
          </div>
          <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2662" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2663" />
          <p className="s23 s192 s31 s32 s671 s346 s27 s0 s198 s29 s33 s85 s672" data-node-id="875:2664">
            POSTER 4
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2665">
          <div className="s192 s69 s673 s340 s0 s70 s198 s71" data-node-id="875:2666" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s674 s675 s9 s676 s677" src={img2026923384} />
            </div>
          </div>
          <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2667" />
          <div className="s80 s192 s81 s69 s647 s340 s82 s0 s70 s198 s71" data-node-id="875:2668" />
          <p className="s23 s192 s31 s94 s678 s346 s27 s0 s198 s29 s33 s85 s679" data-node-id="875:2669">
            GUIDE CARDS
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2670">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2671" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s7 s680 s9 s10 s681" src={img2026923385} />
            </div>
          </div>
          <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s79 s71" data-node-id="875:2672" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2673" />
          <p className="s23 s192 s31 s94 s682 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:2674">
            POSTCARDS
          </p>
        </div>
      </div>
      <div className="s2 s102 s103 s10 s104" data-node-id="875:2675">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle245} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s683 s108 s109" data-node-id="875:2676" data-name="navigationbar">
        <div className="s16 s17 s110 s26 s0 s28" data-node-id="875:2677">
          <div className="s111 s0 s28 s112" data-node-id="875:2678" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="875:2683">
            DING AI LAB
          </p>
        </div>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="875:2684">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="875:2685">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:2686">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:2687">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="875:2688">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:2689">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:2690">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="875:2691">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:2692">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:2693">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
      <div className="s106 s2 s125 s126 s10 s104" data-node-id="875:2694">
        <div className="s2 s127">
          <img alt="" className="s49 s9 s1" src={imgRectangle246} />
        </div>
      </div>
      <div className="s106 s2 s128 s126 s10 s104" data-node-id="875:2695">
        <div className="s2 s129">
          <img alt="" className="s49 s9 s1" src={imgRectangle247} />
        </div>
      </div>
      <div className="s2 s67 s153 s923" data-node-id="875:1794">
        <div className="s2 s5 s924 s153 s156 s157 s923 s158" data-node-id="856:3146" />
        <p className="s23 s2 s31 s32 s925 s27 s29 s160 s926 s54" data-node-id="856:3147">
          postcards
        </p>
        <div className="s2 s862 s189 s927 s522" data-node-id="856:3162" data-name="-15.png 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={img15Png1} />
        </div>
        <p className="s23 s2 s31 s32 s209 s27 s29 s137 s928 s54" data-node-id="856:3163">
          POSTCARDS DESIGN
        </p>
        <div className="s2 s929 s930 s185 s186 s433 s931 s189 s932 s522" data-node-id="856:3164">
          <div className="s933 s192 s197 s0 s198 s28" data-node-id="856:3165" data-name="KakaoTalk_Photo_2026-09-15-22-33-20 002 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgKakaoTalkPhoto202609152233200021} />
          </div>
          <div className="s933 s203 s197 s0 s198 s28" data-node-id="856:3166" data-name="KakaoTalk_Photo_2026-09-15-22-33-20 003 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgKakaoTalkPhoto202609152233200031} />
          </div>
          <div className="s934 s205 s197 s0 s198 s28" data-node-id="856:3167" data-name="KakaoTalk_Photo_2026-09-15-22-33-21 006 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgKakaoTalkPhoto202609152233210061} />
          </div>
          <div className="s934 s192 s197 s0 s206 s28" data-node-id="856:3168" data-name="KakaoTalk_Photo_2026-09-15-22-33-21 008 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgKakaoTalkPhoto202609152233210081} />
          </div>
          <div className="s933 s203 s197 s0 s206 s28" data-node-id="856:3169" data-name="KakaoTalk_Photo_2026-09-15-22-33-19 001 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgKakaoTalkPhoto202609152233190011} />
          </div>
          <div className="s933 s205 s197 s0 s206 s28" data-node-id="856:3170" data-name="KakaoTalk_Photo_2026-09-15-22-33-21 004 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgKakaoTalkPhoto202609152233210041} />
          </div>
          <div className="s934 s192 s197 s0 s430 s28" data-node-id="856:3171" data-name="KakaoTalk_Photo_2026-09-15-22-33-21 009 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgKakaoTalkPhoto202609152233210091} />
          </div>
          <div className="s934 s203 s197 s0 s430 s28" data-node-id="856:3172" data-name="KakaoTalk_Photo_2026-09-15-22-33-21 005 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgKakaoTalkPhoto202609152233210051} />
          </div>
          <div className="s934 s205 s197 s0 s430 s28" data-node-id="856:3173" data-name="KakaoTalk_Photo_2026-09-15-22-33-21 007 1">
            <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgKakaoTalkPhoto202609152233210071} />
          </div>
        </div>
      </div>
      <div className="s2 s16 s17 s24 s130 s26 s20 s132 s133" data-node-id="875:2709" data-name="PROJECT_CATEGORY_TABS_GRAPHIC2">
        <p className="s23 s31 s32 s379 s27 s0 s28 s137 s138 s380" data-node-id="856:3302">
          GRAPHIC 2
        </p>
        <div className="s16 s17 s139 s18 s0 s28 s140" data-node-id="856:3148" data-name="PROJECT_CATEGORY_TABS_GRAPHIC2">
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3149" data-name="TAB_POSTER1">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3150">
              POSTER 1
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3151" data-name="TAB_POSTER2">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3152">
              POSTER 2
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3153" data-name="TAB_POSTER3">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3154">
              POSTER 3
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3155" data-name="TAB_POSTER4">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3156">
              POSTER 4
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3157" data-name="TAB_GUIDECARDS">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3158">
              GUIDE CARDS
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <div className="s16 s81 s17 s18 s42 s142 s143 s144 s0 s145 s28" data-node-id="856:3159" data-name="TAB_POSTCARDS">
            <div aria-hidden className="s2 s152 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s29 s148 s54" data-node-id="856:3160">
              POSTCARDS
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </div>
        </div>
      </div>
      <button className="s2 s49 s141 s935 s212 s213" data-node-id="908:229" data-name="close">
        <img alt="" className="s2 s49 s3 s9 s1" src={imgClose} />
      </button>
    </div>
  );
}